import { api } from "@/lib/api";

const request = (method, url, householdId, data) =>
  api.request({
    method,
    url,
    data,
    params: {
      household_id: householdId,
    },
  });

export async function listKnownSenders(householdId) {
  const response = await request("get", "/comms/known-senders", householdId);
  return Array.isArray(response?.data) ? response.data : [];
}

export async function addKnownSender(householdId, email) {
  const response = await request("post", "/comms/known-senders", householdId, { email });
  return response?.data || null;
}

export async function editKnownSender(householdId, id, email) {
  const response = await request("put", `/comms/known-senders/${id}`, householdId, { email });
  return response?.data || null;
}

export async function removeKnownSender(householdId, id) {
  const response = await request("delete", `/comms/known-senders/${id}`, householdId);
  return response?.data || { ok: false };
}
